var render = function render(){var _vm=this,_c=_vm._self._c;return (this.condition())?_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(this.prefix))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(this.displayText() + this.suffix))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }